var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.66981C5.66981 5.66981 9.91509 4.39623 13.3113 1C16.7075 4.39623 20.9528 5.66981 25.6226 5.66981C25.6226 5.81132 25.6226 5.81132 25.6226 5.95283C25.6226 8.07547 25.6226 10.0566 25.6226 12.1792C25.6226 14.7264 25.3396 17.1321 24.7736 19.6792C23.6415 23.783 21.2358 27.0377 17.5566 29.1604C16.283 30.0094 14.8679 30.5755 13.4528 31C13.3113 31 13.1698 31 13.1698 31C11.0472 30.2925 8.92453 29.1604 7.22642 27.7453C4.67925 25.7642 2.98113 23.217 1.99057 20.1038C1.28302 17.9811 1 15.8585 1 13.7358C1 11.0472 1 8.5 1 5.81132C1 5.81132 1 5.66981 1 5.66981Z",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.9961L10.75 20.4961L7 17.087",
    stroke: "#3361CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadges);
export default __webpack_public_path__ + "static/media/Badges.63ee90c1c541016e8775c7600f8f54e8.svg";
export { ForwardRef as ReactComponent };